import React from 'react';

import cs from 'classnames';

import {
  convertLocationParamsToFetchParams,
  useDocuments,
} from 'app/documents/api';
import {VeryCompactListItem} from 'app/documents/components/VeryCompactListItem';
import {gt} from 'app/utils/i18n';

import {DashboardListWidget} from './DashboardListWidget';

import type {SortOptionType} from 'app/utils/constants';

interface Props {
  icon: string;
  title: string;
  filter: string;
  sortBy: SortOptionType;
}

const SMALL_PAGE_SIZE = '3';

export function DocumentActionRequiredList({
  icon,
  title,
  filter,
  sortBy,
}: Props) {
  function noop() {
    return;
  }

  return (
    <DashboardListWidget
      icon={icon}
      title={title}
      hook={useDocuments}
      params={convertLocationParamsToFetchParams({
        filter,
        page_size: SMALL_PAGE_SIZE,
      })}
      emptyMessage={gt('No Documents')}
      renderItem={(document, _index, isLast) => (
        <VeryCompactListItem
          className={cs({'border-0': isLast})}
          object={document}
          refreshData={() => undefined}
          sortBy={sortBy}
          mySignoffs={[]}
          contentType={document.document_content_type}
          enableBulkSelect={false}
          isSelected={false}
          addToSelection={noop}
          removeFromSelection={noop}
        />
      )}
    />
  );
}
